// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --rev-green: #277a3e;
  --rev-green-dark: #17552a;
  --rev-green-soft: #eaf4ed;

  --rev-yellow: #f5d000;
  --rev-yellow-soft: #fff8cc;

  --surface: #ffffff;
  --surface-muted: #f7faf7;
  --page-background: #f4f7f4;

  --text-primary: #17211a;
  --text-secondary: #617067;

  --border: #d9e2dc;
  --border-strong: #becbc2;

  --shadow:
    0 1px 2px rgba(23, 33, 26, 0.05),
    0 10px 28px rgba(23, 33, 26, 0.08);
}

.charts-panel {
  width: min(1400px, calc(100% - 40px));
  max-width: 100%;
  margin: 28px auto 48px;
  background: var(--surface);
  border: 1px solid var(--border);
  border-top: 5px solid var(--rev-green);
  border-radius: 18px;
  box-shadow: var(--shadow);
  overflow: hidden;
  box-sizing: border-box;
}

.charts-panel-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 24px;
  padding: 26px 28px 22px;
}

.charts-eyebrow {
  display: block;
  margin-bottom: 5px;
  color: var(--rev-green);
  font-size: 0.75rem;
  font-weight: 800;
  letter-spacing: 0.12em;
  text-transform: uppercase;
}

.charts-panel-header h2 {
  margin: 0;
  color: var(--text-primary);
  font-size: clamp(1.45rem, 2vw, 2rem);
  line-height: 1.2;
}

.charts-panel-header p {
  max-width: 650px;
  margin: 8px 0 0;
  color: var(--text-secondary);
  font-size: 0.92rem;
  line-height: 1.5;
}

.charts-filter-status {
  flex-shrink: 0;
  padding: 8px 13px;
  background: var(--rev-yellow-soft);
  border: 1px solid #ebd650;
  border-radius: 999px;
  color: #665700;
  font-size: 0.84rem;
  font-weight: 750;
}

.chart-tabs {
  display: flex;
  gap: 4px;
  padding: 0 28px;
  overflow-x: auto;
  overflow-y: hidden;
  background: var(--surface-muted);
  border-top: 1px solid var(--border);
  border-bottom: 1px solid var(--border);
  scrollbar-width: thin;
}

.chart-tab {
  position: relative;
  flex: 0 0 auto;
  min-height: 54px;
  padding: 0 20px;
  background: transparent;
  border: 0;
  color: var(--text-secondary);
  font-size: 0.9rem;
  font-weight: 700;
  white-space: nowrap;
  cursor: pointer;
  transition:
    color 150ms ease,
    background 150ms ease;
}

.chart-tab:hover {
  color: var(--rev-green-dark);
  background: var(--rev-green-soft);
}

.chart-tab::after {
  content: "";
  position: absolute;
  right: 16px;
  bottom: 0;
  left: 16px;
  height: 3px;
  background: transparent;
  border-radius: 999px 999px 0 0;
}

.chart-tab-active {
  color: var(--rev-green-dark);
  background: var(--surface);
}

.chart-tab-active::after {
  background: var(--rev-yellow);
}

.chart-tab:focus-visible {
  outline: 3px solid rgba(39, 122, 62, 0.25);
  outline-offset: -3px;
}

.chart-tab-content {
  min-width: 0;
  padding: 26px 28px 30px;
}

.chart-topic-heading {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  gap: 24px;
  margin-bottom: 20px;
}

.chart-topic-heading h3 {
  margin: 0;
  color: var(--text-primary);
  font-size: 1.2rem;
}

.chart-topic-heading p {
  max-width: 620px;
  margin: 4px 0 0;
  color: var(--text-secondary);
  font-size: 0.88rem;
  line-height: 1.5;
}

.chart-topic-grid {
  display: grid;
  grid-template-columns: minmax(0, 1fr);
  gap: 28px;
  align-items: stretch;
  min-width: 0;
}

.chart-card {
  width: 100%;
  min-width: 0;
  padding: 22px;
  background: var(--surface);
  border: 1px solid var(--border);
  border-radius: 14px;
  box-shadow:
    0 1px 2px rgba(23, 33, 26, 0.04),
    0 6px 18px rgba(23, 33, 26, 0.05);
  box-sizing: border-box;
  overflow: hidden;
}

.chart-card-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 18px;
  margin-bottom: 18px;
}

.chart-card-title {
  min-width: 0;
}

.chart-card h2 {
  margin: 0;
  color: var(--text-primary);
  font-size: 1rem;
  line-height: 1.35;
}

.chart-card-title p {
  margin: 6px 0 0;
  color: var(--text-secondary);
  font-size: 0.82rem;
  line-height: 1.45;
}

.chart-canvas-container {
  position: relative;
  width: 100%;
  min-width: 0;
  height: 520px;
}

.chart-card canvas {
  display: block;
  max-width: 100%;
}

.chart-tabs::-webkit-scrollbar {
  height: 7px;
}

.chart-tabs::-webkit-scrollbar-track {
  background: #edf1ee;
}

.chart-tabs::-webkit-scrollbar-thumb {
  background: #afbeb3;
  border-radius: 999px;
}

.chart-tabs::-webkit-scrollbar-thumb:hover {
  background: var(--rev-green);
}

@media (max-width: 1050px) {
  .charts-panel {
    width: calc(100% - 32px);
  }

  .chart-canvas-container {
    height: 460px;
  }
}

@media (max-width: 700px) {
  .charts-panel {
    width: calc(100% - 20px);
    margin: 16px auto 30px;
    border-radius: 14px;
  }

  .charts-panel-header {
    flex-direction: column;
    align-items: stretch;
    gap: 14px;
    padding: 20px;
  }

  .charts-filter-status {
    align-self: flex-start;
  }

  .chart-tabs {
    padding: 0 10px;
  }

  .chart-tab {
    min-height: 50px;
    padding: 0 14px;
    font-size: 0.82rem;
  }

  .chart-tab-content {
    padding: 20px;
  }

  .chart-topic-heading {
    flex-direction: column;
    align-items: flex-start;
    gap: 6px;
  }

  .chart-card {
    padding: 16px;
  }

  .chart-card-header {
    flex-direction: column;
    align-items: stretch;
  }

  .chart-toolbar {
    width: 100%;
    max-width: 100%;
    overflow-x: auto;
    justify-content: flex-start;
  }

  .chart-canvas-container {
    height: 400px;
  }
}

@media (max-width: 480px) {
  .charts-panel {
    width: calc(100% - 12px);
    margin: 10px auto 24px;
    border-radius: 12px;
  }

  .charts-panel-header {
    padding: 16px;
  }

  .charts-panel-header h2 {
    font-size: 1.35rem;
  }

  .charts-panel-header p {
    font-size: 0.84rem;
  }

  .chart-tab-content {
    padding: 12px;
  }

  .chart-card {
    padding: 12px;
    border-radius: 11px;
  }

  .chart-card h2 {
    font-size: 0.95rem;
  }

  .chart-card-title p {
    font-size: 0.76rem;
  }

  .chart-toolbar {
    padding: 4px;
  }

  .chart-toolbar button {
    width: 32px;
    height: 32px;
    flex: 0 0 32px;
  }

  .chart-canvas-container {
    height: 340px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/Charts/ChartTabs.css"],"names":[],"mappings":"AAAA;EACE,oBAAoB;EACpB,yBAAyB;EACzB,yBAAyB;;EAEzB,qBAAqB;EACrB,0BAA0B;;EAE1B,kBAAkB;EAClB,wBAAwB;EACxB,0BAA0B;;EAE1B,uBAAuB;EACvB,yBAAyB;;EAEzB,iBAAiB;EACjB,wBAAwB;;EAExB;;sCAEoC;AACtC;;AAEA;EACE,qCAAqC;EACrC,eAAe;EACf,sBAAsB;EACtB,0BAA0B;EAC1B,+BAA+B;EAC/B,sCAAsC;EACtC,mBAAmB;EACnB,yBAAyB;EACzB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,SAAS;EACT,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,SAAS;EACT,0BAA0B;EAC1B,oCAAoC;EACpC,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,4BAA4B;EAC5B,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,kCAAkC;EAClC,yBAAyB;EACzB,oBAAoB;EACpB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,gCAAgC;EAChC,mCAAmC;EACnC,sCAAsC;EACtC,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,uBAAuB;EACvB,SAAS;EACT,4BAA4B;EAC5B,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf;;yBAEuB;AACzB;;AAEA;EACE,4BAA4B;EAC5B,iCAAiC;AACnC;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,UAAU;EACV,WAAW;EACX,uBAAuB;EACvB,8BAA8B;AAChC;;AAEA;EACE,4BAA4B;EAC5B,0BAA0B;AAC5B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,0CAA0C;EAC1C,oBAAoB;AACtB;;AAEA;EACE,YAAY;EACZ,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,qBAAqB;EACrB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,0BAA0B;EAC1B,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,4BAA4B;EAC5B,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,oBAAoB;EACpB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,0BAA0B;EAC1B,+BAA+B;EAC/B,mBAAmB;EACnB;;qCAEmC;EACnC,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,SAAS;EACT,0BAA0B;EAC1B,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,4BAA4B;EAC5B,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE;IACE,wBAAwB;EAC1B;;EAEA;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,wBAAwB;IACxB,sBAAsB;IACtB,mBAAmB;EACrB;;EAEA;IACE,sBAAsB;IACtB,oBAAoB;IACpB,SAAS;IACT,aAAa;EACf;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,gBAAgB;IAChB,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,QAAQ;EACV;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,sBAAsB;IACtB,oBAAoB;EACtB;;EAEA;IACE,WAAW;IACX,eAAe;IACf,gBAAgB;IAChB,2BAA2B;EAC7B;;EAEA;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,wBAAwB;IACxB,sBAAsB;IACtB,mBAAmB;EACrB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,cAAc;EAChB;;EAEA;IACE,aAAa;EACf;AACF","sourcesContent":[":root {\n  --rev-green: #277a3e;\n  --rev-green-dark: #17552a;\n  --rev-green-soft: #eaf4ed;\n\n  --rev-yellow: #f5d000;\n  --rev-yellow-soft: #fff8cc;\n\n  --surface: #ffffff;\n  --surface-muted: #f7faf7;\n  --page-background: #f4f7f4;\n\n  --text-primary: #17211a;\n  --text-secondary: #617067;\n\n  --border: #d9e2dc;\n  --border-strong: #becbc2;\n\n  --shadow:\n    0 1px 2px rgba(23, 33, 26, 0.05),\n    0 10px 28px rgba(23, 33, 26, 0.08);\n}\n\n.charts-panel {\n  width: min(1400px, calc(100% - 40px));\n  max-width: 100%;\n  margin: 28px auto 48px;\n  background: var(--surface);\n  border: 1px solid var(--border);\n  border-top: 5px solid var(--rev-green);\n  border-radius: 18px;\n  box-shadow: var(--shadow);\n  overflow: hidden;\n  box-sizing: border-box;\n}\n\n.charts-panel-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  gap: 24px;\n  padding: 26px 28px 22px;\n}\n\n.charts-eyebrow {\n  display: block;\n  margin-bottom: 5px;\n  color: var(--rev-green);\n  font-size: 0.75rem;\n  font-weight: 800;\n  letter-spacing: 0.12em;\n  text-transform: uppercase;\n}\n\n.charts-panel-header h2 {\n  margin: 0;\n  color: var(--text-primary);\n  font-size: clamp(1.45rem, 2vw, 2rem);\n  line-height: 1.2;\n}\n\n.charts-panel-header p {\n  max-width: 650px;\n  margin: 8px 0 0;\n  color: var(--text-secondary);\n  font-size: 0.92rem;\n  line-height: 1.5;\n}\n\n.charts-filter-status {\n  flex-shrink: 0;\n  padding: 8px 13px;\n  background: var(--rev-yellow-soft);\n  border: 1px solid #ebd650;\n  border-radius: 999px;\n  color: #665700;\n  font-size: 0.84rem;\n  font-weight: 750;\n}\n\n.chart-tabs {\n  display: flex;\n  gap: 4px;\n  padding: 0 28px;\n  overflow-x: auto;\n  overflow-y: hidden;\n  background: var(--surface-muted);\n  border-top: 1px solid var(--border);\n  border-bottom: 1px solid var(--border);\n  scrollbar-width: thin;\n}\n\n.chart-tab {\n  position: relative;\n  flex: 0 0 auto;\n  min-height: 54px;\n  padding: 0 20px;\n  background: transparent;\n  border: 0;\n  color: var(--text-secondary);\n  font-size: 0.9rem;\n  font-weight: 700;\n  white-space: nowrap;\n  cursor: pointer;\n  transition:\n    color 150ms ease,\n    background 150ms ease;\n}\n\n.chart-tab:hover {\n  color: var(--rev-green-dark);\n  background: var(--rev-green-soft);\n}\n\n.chart-tab::after {\n  content: \"\";\n  position: absolute;\n  right: 16px;\n  bottom: 0;\n  left: 16px;\n  height: 3px;\n  background: transparent;\n  border-radius: 999px 999px 0 0;\n}\n\n.chart-tab-active {\n  color: var(--rev-green-dark);\n  background: var(--surface);\n}\n\n.chart-tab-active::after {\n  background: var(--rev-yellow);\n}\n\n.chart-tab:focus-visible {\n  outline: 3px solid rgba(39, 122, 62, 0.25);\n  outline-offset: -3px;\n}\n\n.chart-tab-content {\n  min-width: 0;\n  padding: 26px 28px 30px;\n}\n\n.chart-topic-heading {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-end;\n  gap: 24px;\n  margin-bottom: 20px;\n}\n\n.chart-topic-heading h3 {\n  margin: 0;\n  color: var(--text-primary);\n  font-size: 1.2rem;\n}\n\n.chart-topic-heading p {\n  max-width: 620px;\n  margin: 4px 0 0;\n  color: var(--text-secondary);\n  font-size: 0.88rem;\n  line-height: 1.5;\n}\n\n.chart-topic-grid {\n  display: grid;\n  grid-template-columns: minmax(0, 1fr);\n  gap: 28px;\n  align-items: stretch;\n  min-width: 0;\n}\n\n.chart-card {\n  width: 100%;\n  min-width: 0;\n  padding: 22px;\n  background: var(--surface);\n  border: 1px solid var(--border);\n  border-radius: 14px;\n  box-shadow:\n    0 1px 2px rgba(23, 33, 26, 0.04),\n    0 6px 18px rgba(23, 33, 26, 0.05);\n  box-sizing: border-box;\n  overflow: hidden;\n}\n\n.chart-card-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  gap: 18px;\n  margin-bottom: 18px;\n}\n\n.chart-card-title {\n  min-width: 0;\n}\n\n.chart-card h2 {\n  margin: 0;\n  color: var(--text-primary);\n  font-size: 1rem;\n  line-height: 1.35;\n}\n\n.chart-card-title p {\n  margin: 6px 0 0;\n  color: var(--text-secondary);\n  font-size: 0.82rem;\n  line-height: 1.45;\n}\n\n.chart-canvas-container {\n  position: relative;\n  width: 100%;\n  min-width: 0;\n  height: 520px;\n}\n\n.chart-card canvas {\n  display: block;\n  max-width: 100%;\n}\n\n.chart-tabs::-webkit-scrollbar {\n  height: 7px;\n}\n\n.chart-tabs::-webkit-scrollbar-track {\n  background: #edf1ee;\n}\n\n.chart-tabs::-webkit-scrollbar-thumb {\n  background: #afbeb3;\n  border-radius: 999px;\n}\n\n.chart-tabs::-webkit-scrollbar-thumb:hover {\n  background: var(--rev-green);\n}\n\n@media (max-width: 1050px) {\n  .charts-panel {\n    width: calc(100% - 32px);\n  }\n\n  .chart-canvas-container {\n    height: 460px;\n  }\n}\n\n@media (max-width: 700px) {\n  .charts-panel {\n    width: calc(100% - 20px);\n    margin: 16px auto 30px;\n    border-radius: 14px;\n  }\n\n  .charts-panel-header {\n    flex-direction: column;\n    align-items: stretch;\n    gap: 14px;\n    padding: 20px;\n  }\n\n  .charts-filter-status {\n    align-self: flex-start;\n  }\n\n  .chart-tabs {\n    padding: 0 10px;\n  }\n\n  .chart-tab {\n    min-height: 50px;\n    padding: 0 14px;\n    font-size: 0.82rem;\n  }\n\n  .chart-tab-content {\n    padding: 20px;\n  }\n\n  .chart-topic-heading {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 6px;\n  }\n\n  .chart-card {\n    padding: 16px;\n  }\n\n  .chart-card-header {\n    flex-direction: column;\n    align-items: stretch;\n  }\n\n  .chart-toolbar {\n    width: 100%;\n    max-width: 100%;\n    overflow-x: auto;\n    justify-content: flex-start;\n  }\n\n  .chart-canvas-container {\n    height: 400px;\n  }\n}\n\n@media (max-width: 480px) {\n  .charts-panel {\n    width: calc(100% - 12px);\n    margin: 10px auto 24px;\n    border-radius: 12px;\n  }\n\n  .charts-panel-header {\n    padding: 16px;\n  }\n\n  .charts-panel-header h2 {\n    font-size: 1.35rem;\n  }\n\n  .charts-panel-header p {\n    font-size: 0.84rem;\n  }\n\n  .chart-tab-content {\n    padding: 12px;\n  }\n\n  .chart-card {\n    padding: 12px;\n    border-radius: 11px;\n  }\n\n  .chart-card h2 {\n    font-size: 0.95rem;\n  }\n\n  .chart-card-title p {\n    font-size: 0.76rem;\n  }\n\n  .chart-toolbar {\n    padding: 4px;\n  }\n\n  .chart-toolbar button {\n    width: 32px;\n    height: 32px;\n    flex: 0 0 32px;\n  }\n\n  .chart-canvas-container {\n    height: 340px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
